import {some} from 'lodash-es';

// A function that reveals whether or not a user has at least one elementary
// classroom. This is achieved by checking a classroom's 'is_all_ages'
// value -- a property that is synonymous with 'is_elementary').
export const hasElementaryClassroom = (classrooms) => {
  return some(classrooms, 'is_all_ages');
};
